// extracted by mini-css-extract-plugin
export default {"priorityCriticalIcon":"styles__priorityCriticalIcon__bd2795cc58ccbd9d4f22"};